import { TbaTransactionOverview as Component } from './components/TbaTransactionOverview';
import Connector from './connector';

export const TbaTransactionOverview = () => {
  return <Connector component={Component} />;
};
